import ArrowIcon from '~/assets/icons/Arrow';

export const ArrowIconWithBackground = () => {
  return (
    <div className="flex size-8 items-center justify-center rounded-3xl bg-grey-panel-dark">
      <ArrowIcon fill="#ffffff" height="24" width="24" />
    </div>
  );
};
